<div class="model-bio-dialog">
    <div class="dialog-header">
      <h2>{{ data?.name || 'Model Details' }}</h2>
      <button type="button" class="close-btn" (click)="closeDialog()" aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  
    <div class="dialog-meta">
      <span>{{ data?.provider || 'AI Provider' }}</span>
      <span *ngIf="data?.modelId"> · {{ data?.modelId }}</span>
    </div>
  
    <p class="dialog-copy">
      {{ data?.blurb || 'This model is available in ClariChat for generation, analysis, and workflow automation use cases.' }}
    </p>
  
    <p class="dialog-copy">
      This model does not yet have a dedicated bio component, so this detailed dialog is used as a fallback.
      You can still select it from Model Garden and start a new chat immediately.
    </p>
  </div>
  